import { Component, OnInit } from '@angular/core';
import { NotificationBuilder } from '../shared/notificationBuilder';
import { HelperService } from '../services/helper.service';
import { StoreUserService } from './storeUser.service';
import { Profile } from '../models/profile.model';
import { ProfileService } from '../profile/profile.service';

@Component({
  selector: 'app-storeusers',
  templateUrl: './storeUsers.component.html',
  styleUrls: ['./storeUsers.component.css']
})

export class StoreUserComponent implements OnInit {
  loading: boolean;
  users: any;
  icons: any;
  profile: Profile;
  isHeroOrTravel: boolean;

  constructor(private storeUserService: StoreUserService, private profileService: ProfileService, private helperService: HelperService, private notificationBuilder: NotificationBuilder) {
  }

  ngOnInit() {
    debugger
    this.profileService.getCurrentUserInfo().subscribe(profile => {
      this.profile = profile;
      this.isHeroOrTravel = this.profile.storeSeoName == "heroseguros" || this.profile.storeSeoName == "mytravelassist";
      console.log(this.profile.storeSeoName);
      this.storeUserService.getList().subscribe(res => {
        if (res.success) {
          this.users = res.data;
          console.log(this.users);
          this.loading = false;
        }
      })
    })
  }
}
